import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import BottomNav from './BottomNav';

const DashboardLayout = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {!isMobile && <Sidebar />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          bgcolor: 'background.default',
        }}
      >
        <Header />
        <Box
          sx={{
            flexGrow: 1,
            p: 0,
            pb: isMobile ? 7 : 3, // Add padding at bottom for mobile navigation
          }}
        >
          {children}
        </Box>
        {isMobile && <BottomNav />}
      </Box>
    </Box>
  );
};

export default DashboardLayout;